<ng-container *ngIf="loading">
    <mapfre-loading></mapfre-loading>
</ng-container>

<mapfre-modal 
    [modalOptions]="enrollEditModalOptions" 
    [hideModal]="hideModal" 
    (hideModalOutput)="resetHideModal()"
>
    <div class="modal-body eft-confirm-container-modal">
        <div class="text-center">
            <div class="modal-icon-box-center">
                <img src={{modalIcon}} alt="unenroll icon"/>
            </div>
            <div class="autopay-title modal-title-width" *ngIf="action === 'enroll'">
                Enroll your {{ policy?.displayType?.label | lowercase }} policy 
                {{ policy?.policynumber.policyNumber }} in autopay
            </div>
            <div class="autopay-title modal-title-width" *ngIf="action === 'edit'">
                Edit your {{ policy?.displayType?.label | lowercase }} policy 
                {{ policy?.policynumber.policyNumber }} details
            </div>
        </div>
            <ng-container *ngIf="policy?.billingDetails[0]?.badCheckCount === 'N'">
                <div class="text-center autopay-modal-sub-title mt-2" *ngIf="action === 'enroll'">
                    {{ 'Choose your payment preference:' }}
                </div>
                <div class="payment-method-col mt-4">
                    <div class="payment-info-btn">
                        <div class="payment-info-col"> 
                            <div class="payment-type-info" *ngIf="!policy?.autoPayDetails?.cardType">
                                {{ 'Checking/savings account' }}
                            </div>
                            <div class="details width-web-311" *ngIf="action === 'enroll'">
                                {{ 'To set up your checking or savings account, simply enter your bank account details and choose a date!' }}
                            </div>
                            <div class="details width-web-311" *ngIf="action === 'edit'">
                                {{ 'Update Account details and/or monthly deduction date.' }}
                            </div>
                        </div>   
                        <mapfre-button *ngIf="action === 'enroll'" (click)="onActionClick()" additionalClasses="basic primary w-100-mobile" >
                            {{ "Enroll" | translate }}
                        </mapfre-button>
                        <mapfre-button *ngIf="action === 'edit'" (click)="onActionClick()" additionalClasses="basic primary w-100-mobile" >
                            {{ "Edit" | translate }}
                        </mapfre-button>
                    </div>  

                    <div class="payment-info-btn" *ngIf="action === 'enroll'">
                        <div class="payment-info-col"> 
                            <div class="payment-type-info">
                                {{ 'Credit/debit card' }}
                            </div>
                            <div class="details">
                                {{ 'Please contact our Customer Service department to enroll' }}
                            </div>
                        </div>
                         <div class="w-100-mobile">
                            <a href="tel:18442954500" class="claim-details-link">
                                1-844-295-4500
                            </a>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="policy?.billingDetails[0]?.badCheckCount === 'Y'">
                <div class="payment-info-btn flex-colm-dir align-center mt-4">
                    <div class="bad-check payment-info-col"> 
                    <ng-container *ngIf="action === 'enroll';else edit">                        
                        <div class="payment-type-info">
                            {{ 'Credit/debit card' }}
                        </div>
                        <div class="details">
                            {{ 'Please contact our Customer Service department to enroll' }}
                        </div>
                    </ng-container>
                    <ng-template #edit>
                        <div class="payment-type-info">
                            {{ 'Looking to update your card details, monthly deduction date or change your payment method?' }}
                        </div>
                        <div class="details">
                            {{ 'To discuss your options, call our Customer Service department' }}
                        </div>
                    </ng-template>
                </div>
                    <div class="w-100-mobile">
                        <a href="tel:18442954500" class="claim-details-link">
                            1-844-295-4500
                        </a>
                    </div>
                </div>
            </ng-container>

        <hr class="devided-line mt-4 mb-4"/>
        <div class="mx-auto align-text-right">
            <div>                              
                <mapfre-button 
                    additionalClasses="ghost secondary large-btn" 
                    (click)="hideModalAction($event)"
                >
                    {{ 'CANCEL' | translate }}
                </mapfre-button>
            </div>
        </div>
    </div>
</mapfre-modal>